export const getCoingeckoCoinId = async (key: string, value: string) => {
	try {
		const res = await fetch(`/api/coin-data/coingecko-coin-id?key=${key}&value=${value}`);
		const id = await res.json();

		return id;
	} catch (e) {
		return null;
	}
};
